<template>
    <div>
        <BACK title="編輯運輸媒合" name='Home'/>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="新增類別" prop="caseType">
                <div class="clear">
                    <el-checkbox v-for="({id, name},idx) in caseType" v-model="interviewOption[idx]" :key="idx"
                                 @change="chengeJobType(idx)">{{name}}
                    </el-checkbox>
                </div>
            </el-form-item>
            <el-form-item label="媒合狀態" prop="isFinish">
                <div class="clear">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.isFinish">
                        <el-option label="進行中" :value="0" />
                        <el-option label="已結束" :value="1" />
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="車輛類型" prop="carType">
                <div class="clear">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.carTypeId">
                        <el-option v-for="({id, name},idx) in carType" :label="name" :value="id" :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="配送日期" prop="startDate">
                <div class="flex">
                    <div class="item hide_close">
                        <!-- <div class="tit">從</div> -->
                        <el-date-picker
                            v-model="startDate"
                            type="date"
                            placeholder="開始日期">
                        </el-date-picker>
                    </div>
                    <div class="item_text">至</div>
                    <div class="item hide_close">
                        <!-- <div class="tit">到</div> -->
                        <el-date-picker
                            v-model="endDate"
                            type="date"
                            align="right"
                            placeholder="結束日期">
                        </el-date-picker>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="選擇地區" prop="areaFrom">
                <div class="flex">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaFromId"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                    <span class="text_pad color_primary">到</span>
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaToId"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="聯絡姓名" prop="contactName">
                <el-input v-model="form.contactName" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡人名稱"></el-input>
            </el-form-item>
            <el-form-item label="聯絡資訊" prop="contactMemo">
                <el-input v-model="form.contactMemo" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡資訊"></el-input>
            </el-form-item>
            <el-form-item label="刊登標題" prop="title">
                <el-input v-model="form.title" type="text" oninput="value=value.replace(value.slice(20),'')" clearable
                          placeholder="輸入標題"></el-input>
            </el-form-item>
            <el-form-item label="內容敘述" prop="content">
                <el-input v-model="form.content" type="textarea"></el-input>
            </el-form-item>
        </el-form>
        <div class="note">*文章均遵守<span class="tag" @click="openTerms">《服務條款》</span></div>
        <div class="btn">
            <el-button type="success" :disabled="loading" @click="handleSubmit()"><i class="el-icon-loading"
                                                                                     v-if="loading"></i>送出
            </el-button>
        </div>
    </div>
</template>
<script>

    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import {mapActions, mapGetters, Store} from 'vuex'
    import moment from 'moment/min/moment-with-locales'

    export default {
        name: 'edit',
        components: {
            BACK
        },
        mixins: [FN],
        data() {
            return {
                interviewOption: {
                    0: false,
                    1: false
                },
                startDate: '',
                endDate: '',
                form: {
                    title: '',
                    areaTo: '',
                    areaToId: '',
                    areaFrom: '',
                    areaFromId: '',
                    caseType: '',
                    caseTypeId: '',
                    carType: '',
                    carTypeId: '',
                    content: '',
                    startDate: '',
                    endDate: '',
                    contactName: '',
                    contactMemo: '',
                    isFinish: ''
                }
            }
        },
        mounted() {
            //取得資料並寫入
            this.getDetail()
        },
        computed: {
            ...mapGetters([
                'caseType',
                'carType',
                'searchArea',
                'caseDetail'
            ]),
            rules() {
                const message = '輸入不完整'
                // 自訂驗證-interviewType
                const isCaseType = (rule, value, callback) => {
                    if (!this.interviewOption[0] && !this.interviewOption[1]) {
                        callback(new Error('請選擇運輸媒合類別'))
                    } else {
                        callback()
                    }
                }
                return {
                    caseType: [
                        {required: true, trigger: 'change', validator: isCaseType}
                    ],
                    areaId: [{required: true, trigger: 'change', message}],
                    title: [{required: true, trigger: 'change', message: "請輸入標題"}],
                    content: [{required: true, trigger: 'change', message: "請輸入內容敘述"}],
                    contactName: [{required: true, trigger: 'change', message: '請輸入聯絡姓名'}],
                    contactMemo: [{required: true, trigger: 'change', message: '請輸入聯絡資訊'}]
                }
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            chengeJobType(idx) {
                if (this.interviewOption[idx]) {
                    this.interviewOption[Math.abs(idx - 1)] = false
                    this.form.caseTypeId = +this.caseType[idx].id
                }
            },
            beforeFormSubmit() {
                this.form.startDate = this.startDate ? moment(this.startDate).format('YYYYMMDD') : ''
                this.form.endDate = this.endDate ? moment(this.endDate).format('YYYYMMDD') : ''
                this.form.areaTo = this.form.areaToId
                this.form.areaFrom = this.form.areaFromId
                this.form.caseType = this.form.caseTypeId
                this.form.carType = this.form.carTypeId
            },
            //送出表單
            handleSubmit() {
                const id = this.$route.params.id
                const form = this.$refs.form
                this.beforeValidate()
                form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.beforeFormSubmit()
                        this.FETCH({
                            key: 'CASE_EDIT',
                            id: id,
                            ...this.form
                        }).then((res) => {
                            //需要accToken的驗證
                            if (+(res || {}).code === -3) {
                                this.checkNewToken(this.handleSubmit)
                            } else {
                                this.handleResponse(res)
                            }
                        })
                    } else {
                        this.loading = false
                        this.handleUnValid()
                    }
                })

            },
            //回應
            handleResponse(res) {
                //const id = this.$route.params.id
                if (!+res.code) {
                    this.$confirm('修改成功', {
                        closeOnClickModal: false,
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            // const { href } = this.$router.resolve({name: 'JobList', params:{ tag: 'my'}})
                            // window.open(href, '_self')
                            this.$router.replace({name: 'Case', params: {tag: 'my'}})
                            this.$parent.handleSearch()
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            getDetail() {
                const id = this.$route.params.id
                this.FETCH({
                    key: 'CASE_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                    if (!+res) {
                        this.form = {
                            ...this.form,
                            ...this.caseDetail
                        }
                        // console.log(this.caseDetail);
                        this.interviewOption[+this.caseDetail.caseTypeId - 1] = true
                        this.startDate = this.caseDetail.startDate
                        this.endDate = this.caseDetail.endDate
                    }
                })
            },
            openTerms() {
                this.$parent.dialogVisible = true
            },
            handleBack() {
                const id = this.$route.params.id
                this.$router.replace({name: 'CaseDetails', params: {id: id}})
            }
        }
    }
</script>
